import { useAuth } from '../../contexts/AuthContext';
import { AlumnoView } from './AlumnoView';
import { DocenteView } from './DocenteView';
import { AdminView } from './AdminView';
import { Spinner } from '../ui/Spinner';

/**
 * Punto de entrada de "Entregables" — decide la vista según el rol del
 * usuario. Cada vista vive en su propio archivo para mantener este árbol
 * legible.
 */
export function Entregables() {
  const { profile, loading } = useAuth();

  if (loading || !profile) {
    return (
      <div className="flex items-center justify-center h-64">
        <Spinner size="lg" />
      </div>
    );
  }

  if (profile.role === 'admin')   return <AdminView />;
  if (profile.role === 'docente') return <DocenteView />;
  return <AlumnoView />;
}
